import Main from "./main";

type Props = {
  compact?: boolean;
};

const NotFound = ({ compact = false }: Props) => {
  const content = (
    <p>Not Found</p>
  );

  if (compact) {
    return content;
  }

  return (
    <Main compact>
      {content}
    </Main>
  );
};

export default NotFound;
